import { Recommendation } from "@/types/social/recommendation/recommendation";
import { Response } from "./types";

export const request = (recommendation: Recommendation): Response => ({
  url: recommendation?.url || null,
  subject: recommendation?.subject || null,
  message: recommendation?.message || null,
  description: recommendation?.description || null
});
